module.exports = __webpack_public_path__ + "static/media/a3.5f4fcdb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chenlong/a3.mp3
// module id = BaL8
// module chunks = 0